export default __webpack_public_path__ + "static/Logo-507e242aaf3a55189ff0d94ba43dc4d0.svg";